import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { authGuard } from '../core/services/auth/auth.guard';
import { CompanyGuard } from '../core/services/company/company.guard';
import { servicesGuard } from './guards/services/services.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'd',
    // loadComponent: () =>
    //   import('./pages/landing/landing.component').then(
    //     (comp) => comp.LandingComponent
    //   ),
    pathMatch: 'full',
  },
  {
    path: 'company/new',
    loadComponent: () =>
      import('./pages/new-company-page/new-company-page.component').then(
        (comp) => comp.NewCompanyPageComponent
      ),
    pathMatch: 'prefix',
  },
  {
    path: 'd',
    loadComponent: () =>
      import('./pages/dashboard/dashboard.component').then(
        (comp) => comp.DashboardComponent
      ),
    pathMatch: 'prefix',
    canActivate: [MsalGuard, authGuard, CompanyGuard],
    children: [
      {
        title: '',
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        title: 'Dashboard',
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/home/home.component').then(
            (comp) => comp.HomeComponent
          ),
        pathMatch: 'full',
      },
      {
        title: 'Services',
        path: 'services',
        loadComponent: () =>
          import('./pages/services-tab/services-tab.component').then(
            (comp) => comp.ServicesTabComponent
          ),
        pathMatch: 'full',
        canActivate: [servicesGuard],
      },
      {
        title: 'Services',
        path: 'services/:id',
        loadComponent: () =>
          import(
            './pages/single-service-page/single-service-page.component'
          ).then((comp) => comp.SingleServicePageComponent),
        pathMatch: 'full',
      },
      {
        title: 'Merchants',
        path: 'merchants',
        loadComponent: () =>
          import('./pages/merchants/merchants.component').then(
            (comp) => comp.MerchantsComponent
          ),
        pathMatch: 'full',
      },
      {
        title: 'Merchants',
        path: 'merchants/:id',
        loadComponent: () =>
          import(
            './pages/single-merchant-page/single-merchant-page.component'
          ).then((comp) => comp.SingleMerchantPageComponent),
        pathMatch: 'full',
      },
      {
        title: 'Transactions',
        path: 'transactions',
        loadComponent: () =>
          import('./pages/transactions/transactions.component').then(
            (comp) => comp.TransactionsComponent
          ),
        pathMatch: 'full',
      },
      {
        title: 'Payment Logs',
        path: 'logs',
        loadComponent: () =>
          import('./pages/entity-logs/entity-logs.component').then(
            (comp) => comp.EntityLogsComponent
          ),
        pathMatch: 'full',
      },
      {
        title: 'Users',
        path: 'users',
        loadComponent: () =>
          import('./pages/users/users.component').then(
            (comp) => comp.UsersComponent
          ),
        pathMatch: 'full',
      },
      {
        title: 'Products',
        path: 'products',
        loadComponent: () =>
          import('./pages/products/products.component').then(
            (comp) => comp.ProductsComponent
          ),
        pathMatch: 'full',
      },
    ],
  },
];
